import { parseAnalyzedData } from "./bap-datalogic";
import { BapParam } from "./bap-param";
import { InputParamGroup, InputParamGroups, isValidInputParamGroups } from "./bap-types";
import { BlockAnalyzed } from "./block-analyzed";
import { BlockAnalyzedParameters } from "./block-analyzed-parameters";
/**
 * Blocco per mostrare un gruppo di parametri
 */
export class BapGroups extends BlockAnalyzed {
    static override webComponentName: string = "bap-groups";
    protected override _templateId: string = "bap-groups";
    
    public initialValue: InputParamGroups | null = null;
    private _parentBlock: BlockAnalyzedParameters;
    public get parentBlock(): BlockAnalyzedParameters {
        if(!this._parentBlock) {
            this._parentBlock =  this.closest('block-analyzed-parameters') as BlockAnalyzedParameters;
        }
        return this._parentBlock;
    }
    private _value: InputParamGroups | null = null;
    public get value(): InputParamGroups | null {
        if (!this._value) {
            this._value = parseAnalyzedData(this.analysData || [], "parameters");
            if (this._value) {
                this.initialValue = this._value;
            }
        }
        return this._value;
    }
    public set value(value: any) {
        if (isValidInputParamGroups(value)) {
            this._value = value;
            this.render();
            if(this.valueIsComplete()) {
                this.parentBlock?.onValueComplete(this._value);
            }
            else {
                this.parentBlock?.onValueChange(this._value);
            }
        }
    }
    public valueIsComplete(): boolean {
        // ritorna true se tutti i parametri hanno un id associato
        if (this.value) {
            for (const group of this.value) {
                for (const param of group) {
                    if (!param.parameter_id) {
                        return false;
                    }
                }
            }
            return true;
        }
        return false;
    }
    constructor() {
        super();
        
    }


    protected buildRenderingData(): Record<string, any> {
        const baseData = super.buildRenderingData();
        return {
            ...baseData,
            value: this.value || []
        };
    }
    async loadSortable() {
        if (!window['Sortable']) {
            await new Promise<void>((resolve, reject) => {
                // carico la libreria SortableJS da url locale ./Sortable.min.js
                const script = document.createElement('script');
                const url = new URL('/Sortable.min.js', window.location.origin);
                script.src = url.toString();
                script.onload = () => {
                    console.log("SortableJS loaded");
                    resolve();
                };
                script.onerror = () => {
                    console.error("Error loading SortableJS");
                    reject();
                };
                document.head.appendChild(script);
            });
        }
    }
    public removeParam(param: BapParam) {
        param.remove();
        this.rebuild();
    }
    public rebuild() {
        const groups = this.querySelectorAll('bap-group');
        const result : InputParamGroups = [];
        groups.forEach((group, groupIndex) => {
            const groupData: InputParamGroup = []; 
            const params = group.querySelectorAll('bap-param');
            params.forEach((param, paramIndex) => {
                groupData.push((param as BapParam).value);
            });
            if(groupData.length > 0) {
                result.push(groupData);
            }
        });
        this.value = result;
    }
    protected afterRender(): void {
        super.afterRender();
        // inizializzo SortableJS sui container di bap-param per permettere drag&drop tra gruppi
        if (window['Sortable']) {
            const groups = this.querySelectorAll('bap-group');
            groups.forEach((group, groupIndex) => {
                // Trovo il container .list-group all'interno del bap-group
                const container = group.querySelector('.list-group.bap-params');
                if (container) {
                    const sortable = window['Sortable'].create(container, {
                        group: 'bap-params', // Gruppo condiviso per permettere spostamenti tra gruppi
                        handle : 'bap-param', // Solo l'handle permette il drag
                        animation: 150,
                        ghostClass: 'bap-param-ghost',
                        chosenClass: 'bap-param-chosen',
                        dragClass: 'bap-param-drag',
                        onEnd: (evt: any) => {
                             this.rebuild();
                        }
                    });
                }
                else {
                    console.warn("Container .list-group.bap-params non trovato in bap-group", groupIndex);
                }
            });
        }
    }

    
    protected async render(): Promise<void> {
        await this.loadSortable();
        super.render();
    }
} 